import {AccountFormContainer} from "../sign-up/common/account-form-container";
import React from "react";
import {PasswordResetForm} from "./password-reset-form";

export const PasswordReset = () => {
    return (
        <AccountFormContainer form={<PasswordResetForm/>}/>
    );
};
